import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ProjectsApiService } from 'src/services/projectsApi'

interface UseGetProjectDashboardQueryParams {
  end?: string
  id?: string
  start?: string
}

export const useGetProjectDashboardQuery = ({
  end,
  id,
  start,
}: UseGetProjectDashboardQueryParams) =>
  useQuery({
    enabled: !!id,
    queryFn: () => ProjectsApiService.getDashboard(id || '', start, end),
    queryKey: [QueryKey.GET_PROJECT_DASHBOARD, id, start, end],
  })
